import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTheme } from '../ThemeContext';
import { BASE_URL } from '../api';

export default function VerifyEmail() {
  const { colors, common } = useTheme();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No verification token found in this link.');
      return;
    }

    fetch(`${BASE_URL}/api/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(res => res.json())
      .then(data => {
        if (data.message) {
          setStatus('success');
          setMessage(data.message);
        } else {
          setStatus('error');
          setMessage(data.error || 'Verification failed.');
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage('Something went wrong. Please try again.');
      });
  }, [searchParams]);

  const icon   = status === 'loading' ? '⏳' : status === 'success' ? '✅' : '❌';
  const colour = status === 'success' ? colors.successText : status === 'error' ? colors.red : colors.textPrimary;
  const title  = status === 'loading' ? 'Verifying your email...'
               : status === 'success' ? 'Email verified!'
               : 'Verification failed';

  return (
    <main style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', backgroundColor: colors.pageBg, padding: 20,
    }}>
      <div style={{
        backgroundColor: colors.cardBg, border: `1px solid ${colors.borderColor}`,
        boxShadow: '0 24px 48px rgba(0,0,0,0.2)', padding: '40px 36px',
        borderRadius: 16, width: '100%', maxWidth: 420, textAlign: 'center',
      }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>{icon}</div>
        <h1 style={{ margin: '0 0 12px', fontSize: 22, fontWeight: 800, color: colour }}>{title}</h1>
        {message && (
          <p style={{ margin: '0 0 28px', color: colors.textSecondary, fontSize: 15, lineHeight: 1.6 }}>
            {message}
          </p>
        )}
        {status === 'success' && (
          <a href="/login"
            style={{ ...common.btn, ...common.btnPrimary, display: 'inline-flex', textDecoration: 'none' }}>
            Sign in to your account
          </a>
        )}
        {status === 'error' && (
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/register"
              style={{ ...common.btn, ...common.btnPrimary, display: 'inline-flex', textDecoration: 'none' }}>
              Register again
            </a>
            <a href="/login"
              style={{ ...common.btn, display: 'inline-flex', textDecoration: 'none', color: colors.textPrimary }}>
              Back to sign in
            </a>
          </div>
        )}
      </div>
    </main>
  );
}
